import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, IconModule, DIALOG_DATA, DialogRef } from '@hglobal/common';

import { AchievementsHistoryModule } from '../../achievements-history.module';

interface DialogData {
  userId: number;
  myTeam: boolean;
}

@Component({
  selector: 'pt-achievements-history-dialog',
  templateUrl: './achievements-history-dialog.component.html',
  styleUrls: ['./achievements-history-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ButtonModule, IconModule, AchievementsHistoryModule],
})
export class AchievementsHistoryDialogComponent {
  data = inject<DialogData>(DIALOG_DATA);
  private readonly _dialogRef = inject(DialogRef);

  close(): void {
    this._dialogRef.close();
  }
}
